var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10561",
    "data-name": "Group 10561",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22.194,
    viewBox: "0 0 22 22.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3057",
    "data-name": "Rectangle 3057",
    width: 22,
    height: 22.194,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10560",
    "data-name": "Group 10560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28901",
    "data-name": "Path 28901",
    d: "M11.1,2.219a8.879,8.879,0,1,0,.988,17.7,1.107,1.107,0,1,1,.243,2.2,10.915,10.915,0,0,1-1.231.07A11.1,11.1,0,1,1,21.575,7.438a1.109,1.109,0,0,1-2.092.734A8.887,8.887,0,0,0,11.1,2.219",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28902",
    "data-name": "Path 28902",
    d: "M10.053,4.11a1.11,1.11,0,1,0-2.219,0V9.2l-3.005,3A1.111,1.111,0,1,0,6.4,13.773l3.329-3.329a1.107,1.107,0,0,0,.324-.786Z",
    transform: "translate(2.153 1.439)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28903",
    "data-name": "Path 28903",
    d: "M9.9,16.254a.528.528,0,0,1,.6-.595H10.8V12.725h-.249q-.555,0-.555-.583v-.089q0-.6.555-.6H10.8V9.689a2.832,2.832,0,0,1,.934-2.132,3.145,3.145,0,0,1,1.045-.614,3.924,3.924,0,0,1,1.336-.219,3.237,3.237,0,0,1,1.256.226,5.574,5.574,0,0,1,.874.445.481.481,0,0,1,.256.388.7.7,0,0,1-.182.46l-.278.364a.575.575,0,0,1-.4.249.8.8,0,0,1-.46-.132,2.64,2.64,0,0,0-.445-.2,1.711,1.711,0,0,0-.577-.095,1.457,1.457,0,0,0-1.051.379,1.247,1.247,0,0,0-.394.935v1.709h1.969a.529.529,0,0,1,.6.6v.089a.522.522,0,0,1-.6.583H12.714v2.934H16.64a.534.534,0,0,1,.613.595v.405a.538.538,0,0,1-.613.607H10.494a.533.533,0,0,1-.6-.607Z",
    transform: "translate(4.746 3.225)",
    fill: "#2e728c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.663c24142d6590d36eda8cc2acf5d66e.svg";
export { ForwardRef as ReactComponent };